import { Modal } from "antd";
import React from "react";
import { svg } from "../../../../../Assets/svg";

const DispatchLastLoadErrorModal = ({
  undispatchedModalOpen,
  setUndispatchedModalOpen,
  undispatchedProductsList,
}: any) => {
  return (
    <Modal
      visible={undispatchedModalOpen}
      onCancel={() => setUndispatchedModalOpen(false)}
      title={
        <div className="text-center fs-4 fw-bolder lh-m mb-2">
          <span className="fs-5 fw-bold text-danger">
            Dispatch Cannot Be Completed!
          </span>
        </div>
      }
      closeIcon={svg.closeIcon}
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={() => setUndispatchedModalOpen(false)}
          >
            CLOSE
          </button>
        </div>
      }
      centered
      width="45rem"
      className="commonModalClass"
    >
      <div className="py-2">
        <p className="text-secondary mb-3">
          This is the last load to be dispatched.Some items have not been fully
          dispatched. Please complete all remaining dispatch quantities before
          marking this load as dispatched.
        </p>
        <div className="table-responsive border rounded-3 overflow-hidden">
          <table className="table table-striped table-hover mb-0 text-dark">
            <thead className="table-light">
              <tr>
                <th>Product</th>
                <th className="text-center">Ordered Qty</th>
                <th className="text-center">Dispatched Qty</th>
                <th className="text-center">Remaining Qty</th>
              </tr>
            </thead>
            <tbody>
              {undispatchedProductsList?.map((p: any, idx: any) => {
                const totalOrdered = Number(p.totalQuantity || 0);
                const totalDispatched = Object.entries(
                  p.dispatchedLoads || {},
                ).reduce(
                  (sum: number, [loadId, qty]) => sum + Number(qty || 0),
                  0,
                );
                const remaining = Math.max(0, totalOrdered - totalDispatched);
                return (
                  <tr key={idx}>
                    <td style={{ verticalAlign: "middle" }}>
                      {p.name || "Unknown Product"}
                    </td>
                    <td
                      className="text-center fw-semibold"
                      style={{ verticalAlign: "middle" }}
                    >
                      {totalOrdered}
                    </td>
                    <td
                      className="text-center fw-semibold text-primary"
                      style={{ verticalAlign: "middle" }}
                    >
                      {totalDispatched}
                    </td>
                    <td
                      className="text-center fw-semibold text-danger"
                      style={{ verticalAlign: "middle" }}
                    >
                      {remaining}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </Modal>
  );
};

export default DispatchLastLoadErrorModal;
